// extracted by mini-css-extract-plugin
module.exports = {"popup":"DealsView_popup__5aQ1_","loading":"DealsView_loading__3cth8","spinner":"DealsView_spinner__3AMdz"};